import { EmailService } from 'src/app/services/email/email.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-contactanos',
  templateUrl: './contactanos.component.html',
  styleUrls: ['./contactanos.component.css']
})
export class ContactanosComponent implements OnInit {
  nombre: string;
  email: string;
  telefono: string;
  message: string;

  constructor(
    private emailService: EmailService,

  ) { }

  ngOnInit() {
    this.nombre = '';
    this.telefono = '';
  }


  onSubmit() {


    this.emailService.EnviarDatosContacto(this.nombre, this.email , this.telefono || 'sin telefono', this.message || 'sin mensaje')
    .subscribe ( resp => {
      Swal.fire(

        'Your message has been sent successfully. <br>Thank you very much.'

      );

      this.nombre = '';
      this.email = '' ;
      this.telefono = '';
    });
  }

}
